import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { globalColors } from "@/utilities/global-variables"
import { FC } from "react"
import { useLocation, useNavigate } from "react-router"
import { useSearchParams } from "react-router-dom"

const { Text } = WebsiteTypography

type Props = {
  type?: "orange" | "darkBlue"
}

const GetFreeQuoteButton: FC<Props> = ({ type = "orange" }) => {
  const { openDarkModal } = useModalDarkContext()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()

  // useEffect(() => {
  //   if (searchParams.get("quote-request") === "true") {
  //     openDarkModal({
  //       type: "get-quote",
  //       isLogo: true,
  //       mode: "default",
  //       width: "widthUndefined",
  //     })
  //   }
  // }, [openDarkModal, searchParams])

  const onGetFreeQuote = () => {
    navigate(`${pathname}?quote-request=true`, { replace: false })
    openDarkModal({
      type: "get-quote",
      isLogo: true,
      mode: "default",
      width: "widthUndefined",
    })
  }

  return (
    <Button
      onClick={onGetFreeQuote}
      style={{ backgroundColor: type === "darkBlue" ? globalColors?.defaultPrimaryColor : undefined, zIndex: 3 }}
      size={"large"}
    >
      <Text size={"md"}>{"GET A QUOTE"}</Text>
    </Button>
  )
}

export default GetFreeQuoteButton
